<template lang="pug">
div.d-flex.align-center
  p.body-1(:style="labelWidth ? `width: ${labelWidth}px` : ''") {{label}}
  v-text-field(outlined hide-details dense v-model="valueModel" :disabled="disabled" :readonly="readonly").pb-3.pl-3
</template>

<script>
export default {
  props: ['value', 'label', 'labelWidth', 'disabled', 'readonly'],
  computed: {
    valueModel: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  }
}
</script>